import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Divider, message, Popconfirm, Popover, Table } from 'antd';
import moment from 'moment';
import { queryRelateTodo, querySaveRelate } from '@api/incubator/finance';
import { querySaveBooksIncome } from '@api/finance/finance';
import util from '@util/index';
import { setBackInfo } from '@store/modules/back_info';
import ModalRelevance from './ModalRelevance';
import ModalDetail from './ModalDetail';

class TableRelating extends Component {
  constructor(props) {
    super(props);
    this.state = {
      relevanceVisible: false,
      data: {
        list: [],
        pagination: {},
      },
      statistics: {},
    };
  }

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.current = backInfo.current;
    }
    this.condition = this.props.condition;
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.current = backInfo.current;
    }
    if (this.props.condition !== nextProps.condition) {
      this.condition = nextProps.condition;
      this.current = 1;
    }
    this.getData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      condition: this.condition,
      current: this.current,
      tabKey: this.props.tabKey,
    };
    this.props.dispatch(setBackInfo(params));
  }

  postRelevance = customUuid => {
    querySaveRelate({
      incomeUuid: this.incomeUuid,
      customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleRelevancevisible(false);
        this.props.handleRefresh();
        this.getData();
      } else {
        message.error(res.message);
      }
    });
  };

  notRelevance = incomeUuid => {
    querySaveRelate({
      incomeUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getData();
        this.props.handleRefresh();
      } else {
        message.error(res.message);
      }
    });
  };

  postEditIncome = params => {
    params.type = this.incomeRecord.type;
    querySaveBooksIncome(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleDetailvisible(false);
        this.getData();
      } else {
        message.error(res.message);
      }
    });
  };

  getData = () => {
    queryRelateTodo({
      incubatorUuid: this.props.params.uuid,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data.data,
            pagination: {
              current: this.current,
              total: res.totalSize,
              pageSize: 15,
            },
          },
          statistics: res.data.statistics,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getData();
  };

  handleRelevancevisible = (flag, incomeUuid) => {
    this.incomeUuid = incomeUuid;
    this.setState({
      relevanceVisible: !!flag,
    });
  };

  handleDetailvisible = (flag, incomeRecord) => {
    this.incomeRecord = incomeRecord;
    this.setState({
      detailVisible: !!flag,
    });
  };

  columns = () => {
    const { accountInfo, paymentTypes } = this.props;
    return [
      {
        title: '日期',
        dataIndex: 'date',
        width: 100,
        render: (text, record, index) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '对方户名',
        dataIndex: 'accountName',
        width: 200,
      },
      {
        title: '金额',
        dataIndex: 'money',
        width: 100,
        render: (text, record) => (
          <span>{util.numberFormat(text === 0 ? record.payMoney : record.money)}</span>
        ),
      },
      {
        title: '类型',
        dataIndex: 'target',
        width: 60,
        render: (text, record) => <span>{text === 0 ? '支出' : '收入'}</span>,
      },
      {
        title: '收支类型',
        dataIndex: 'type',
        key: 'type',
        width: 150,
        render: (text, record) => {
          let typeName = '';
          if (paymentTypes.length > 0) {
            paymentTypes.forEach((item, index) => {
              if (text === item.value) {
                typeName = item.key;
                return typeName;
              }
            });
          }
          return <span>{typeName}</span>;
        },
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        width: 150,
        render: text => {
          const content = text;
          return (
            <Popover content={content}>
              <p
                style={{
                  width: '150px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {text}
              </p>
            </Popover>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        width: 200,
        render: (text, record) => (
          <span>
            {accountInfo.isHatcherMng || accountInfo.isIncubatorMng || accountInfo.isFinancialM ? (
              <span>
                <a onClick={() => this.handleRelevancevisible(true, record.uuid)}>客户关联</a>
                <Divider type="vertical" />
                <Popconfirm
                  title="确认不用关联吗？"
                  onConfirm={() => {
                    this.notRelevance(record.uuid);
                  }}
                >
                  <a>不用关联</a>
                </Popconfirm>
              </span>
            ) : (
              <span>客户关联</span>
            )}
            <Divider type="vertical" />
            <a onClick={() => this.handleDetailvisible(true, record)}>编辑</a>
          </span>
        ),
      },
    ];
  };

  render() {
    const {
      data: { list, pagination },
      relevanceVisible,
      detailVisible,
      statistics,
    } = this.state;
    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <div style={{ textAlign: 'left', width: '200px' }}>
            <span style={{ paddingRight: '8px' }}>收入</span>
            <span>总金额：{util.numberFormat(statistics.incomeSum || 0)}元</span>
          </div>
        </div>
        <div
          style={{
            marginBottom: '16px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <div style={{ textAlign: 'left', width: '200px' }}>
            <span style={{ paddingRight: '8px' }}>支出</span>
            <span>总金额：{util.numberFormat(statistics.expenditureSum || 0)}元</span>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
        {relevanceVisible ? (
          <ModalRelevance
            onCancel={() => this.handleRelevancevisible(false)}
            onOk={this.postRelevance}
            {...this.props}
          />
        ) : null}
        {detailVisible ? (
          <ModalDetail
            onCancel={() => this.handleDetailvisible(false)}
            onOk={this.postEditIncome}
            data={this.incomeRecord}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}
export default connect(state => ({
  accountInfo: state.account_info,
  backInfo: state.back_info,
}))(TableRelating);



// WEBPACK FOOTER //
// ./src/components/incubator/income/TableRelating.js